import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatUnixTimestampToDate, getDateFormat3 } from 'srcReact/helpers/datetimeHelper'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import WidgetContainer from '../WidgetContainer'
import styles from './styles.module.scss'

function FeaturedDoc({ documents, handleShowMore }) {
  const { t } = useTranslation()
  return (
    <WidgetContainer
      title={t('widgets.featuredDoc.title')}
      imageName='paperclip'
      showMoreLabel={t('global.showMore')}
      handleShowMore={handleShowMore}>
      <div className={styles.documentContainer}>
        {documents
          ?.filter((doc, index) => index < 3)
          ?.map((document) => {
            return (
              <DocumentPreview
                showDate={true}
                date={formatUnixTimestampToDate(document.date_time, getDateFormat3())}
                documentNameCSS={styles.documentName}
                documentNameMaxLength={40}
                className={styles.document}
                fileName={document.name}
                showDownload={true}
                showOpened={true}
                extension={document.name.split('.').pop().toLowerCase()}
                mimeType={document.mime_type}
                isOriginal={document.is_original}
                originalTag={document.original_tag}
                path={document.url}
                documentId={document.id}
              />
            )
          })}
      </div>
    </WidgetContainer>
  )
}

export default FeaturedDoc
